import OliveImages from './OliveImages';
import version from './version';
import OLIVE_CDN from './OLIVE_CDN';
export { OliveImages, version, OLIVE_CDN };
export default OliveImages();